import React, { useEffect, useState } from "react";
import { Route, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectAuthentificated, selectCurrentUserRoles, selectKeycloakIsLoading } from "../auth/AuthUserSlice";
import { useKeycloak } from "@react-keycloak/web";

interface Props {
    children: any;
    to: string;
}

const ProtectedRoute = ({ children, to }: Props) => {
    const navigate = useNavigate();
    const authenticated = useSelector(selectAuthentificated);
    const keycloakLoading = useSelector(selectKeycloakIsLoading);
    const currentUserRoles = useSelector(selectCurrentUserRoles);
    const { keycloak, initialized } = useKeycloak();

    const currentLogin = () => {
        keycloak.login();
    };

    useEffect(() => {
       if (!authenticated && keycloakLoading !== "LOADING" && (to.includes("new/projects") || to.includes("list/projects") || to.includes("create/structure") || to.includes("account"))) { 
            currentLogin();
       }
       console.log(keycloakLoading);
    }, [authenticated, keycloakLoading, to]);

    return (
        !!authenticated && (to.includes("new/projects") || to.includes("list/projects")) ? children : (!to.includes("new/projects") ? children : null)
    );
};

export default ProtectedRoute;